<template>
  <div>
    <vxe-grid
      ref="fabricOptional"
      auto-resize
      resizable
      highlight-hover-row
      size="mini"
      :data="tableData"
      :loading="loading"
      :columns="tableColumns"
      :height="350"
      border
      :checkbox-config="{ highlight: true, trigger: 'row' }"
      @checkbox-change="onCheckboxChange"
      @checkbox-all="onCheckboxChange"
    >
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
export default {
  mixins: [TableAutoHeight],
  props: { orderCode: { type: String, default: '' } },
  data() {
    return {
      tableData: [],
      loading: false,
      tableColumns: tableColumns(this),
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    async loadData() {
      if (!this.orderCode) return
      this.loading = true
      const res = await this.$api
        .tcFabricPurchaseDetailOptionalApi({
          orderCode: this.orderCode,
        })
        .catch(() => null)
      this.loading = false
      const { body = {} } = res || {}
      this.tableData = body.data
    },
    onCheckboxChange({ records }) {
      this.$emit('checkbox-change', records)
    },
  },
}
</script>
